import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const CreateAgentButton = () => {
  const navigate = useNavigate();

  const handleCreateAgent = () => {
    navigate('/agent-configuration');
  };

  return (
    <Button
      variant="default"
      size="default"
      iconName="Plus"
      iconPosition="left"
      onClick={handleCreateAgent}
      className="bg-primary hover:bg-primary/90 text-primary-foreground"
    >
      Neuen Agent erstellen
    </Button>
  );
};

export default CreateAgentButton;